import * as React from "react";

interface ProductTileProps {
  url?: string;
  handleAction?: React.MouseEventHandler<HTMLAnchorElement>;
  image: string;
  heading?: string;
  priceLabel?: string;
  priceAfter?: string;
  priceBefore: string;
  rewardsPrice?: string;
  promoNotes?: string | null;
  stockStatus?: string | null;
}

export const UpsellProductTile: React.FunctionComponent<ProductTileProps> = (
  props
) => {
  const [isHovering, setIsHovering] = React.useState(false);

  const handleUpsellClick = (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
    (window as any).dataLayer = (window as any).dataLayer || [];
    (window as any).dataLayer.push({
      event: 'upsell_interaction',
      ecommerce: {
        url: props.url,
        name: props.heading
      }
    });
    props.handleAction?.(e);
  }

  return (
    <article className={`${isHovering ? "hovering" : ""}`}>
      <a
        href={props.url}
        onClick={handleUpsellClick}
        onMouseOver={() => {setIsHovering(true)}}
        onMouseOut={() => {setIsHovering(false)}}
      >
        <div className="upsell-product-image-container"><img src={props.image} /></div>
        <p>
          {props.heading}
        </p>
        <p>
            {props.priceLabel && (
                <span className="label">{props.priceLabel}&nbsp;</span>
            )}
        </p>
        <p className="main-price">
          {props.priceAfter ? (
            <React.Fragment>
              <span className="price-after">&#36;{props.priceAfter}&nbsp;</span>
              <span className="price-before">was &#36;{props.priceBefore}</span>
            </React.Fragment>
          ) : (
            <span className="regular-price">&#36;{props.priceBefore}</span>
          )}
        </p>
        {props.rewardsPrice && (
          <p className="rewards-price">Members: &#36;{props.rewardsPrice}</p>
        )}
      </a>
      <a
        href={props.url}
        onClick={props.handleAction}
        onMouseOver={() => {setIsHovering(true)}}
        onMouseOut={() => {setIsHovering(false)}}
      >
        {props.promoNotes && <p className="promo">{props.promoNotes}</p>}
        {props.stockStatus && (
          <p className="stock-status">{props.stockStatus}</p>
        )}
      </a>
    </article>
  );
};
